import axiosInstance from "./config";

export const login = (data) => {
  return axiosInstance.post("/auth/login", data);
};

export const me = () => {
  return axiosInstance.get("/auth/me");
};
